export const getInitials = (name: string): string => {
  try {
    let initials = [];

    if (!name || name === '') {
      return '';
    }

    let nameArr = name.split(' ');

    for (let str of nameArr) {
      // replace method will remove any special character from the string and then charAt(0) method will take the first letter
      let firstLetter = str.replace(/[^a-zA-Z]/g, '').charAt(0);
      if (firstLetter) initials.push(firstLetter.toUpperCase());
      if (initials.length === 2) break;
    }

    return initials.join('');
  } catch {
    return '';
  }
};